<template>
  
   <installations
   :key="key"
   :allinstallations="installations"
   :completeinstalls="completeInstalls"
   :incompleteinstalls="incompleteInstalls"
     :isloading="isLoading">
   </installations>

</template>
  
 ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>
  import Api from "@/services/Api";
  import format from "date-fns/format";
  import dateformat from "dateformat";

  import installations from "@/components/Installations.vue";
  

export default {
    components: {
    installations: installations,
   
  },
    data() {
      return {
        key: 0,
         isLoading: true,
      installations: [],
      completeInstalls: [],
      incompleteInstalls: []
      };
    },

    computed: {
      pages() {
        if (
          this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        )
          return 0;
        return Math.ceil(
          this.pagination.totalItems / this.pagination.rowsPerPage
        );
      }
    },
     watch: {
      dialog(val) {
        val || this.close();
      }, 
    },
    async created() {
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/installations'})
      if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
    },
    // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    methods: {
       initialize() {
      //this.fetchInstallations();
    },
       search(search){
           this.isLoading=true
      if(search.search!==""){      
        Api()
        .get('/installations',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.installations=response.data
           this.isLoading=false
        })} 
      },
      fetchInstallations() {
          this.isLoading=true
        Api()
          .get("/installations/active")
          .then(async response => {
            this.installations = response.data;
            this.completeInstalls = await this.installations.filter(function(el){
              return el.status === 'Complete'
            })
            this.incompleteInstalls = await this.installations.filter(function(el){
              return el.status !== 'Complete'
            })
             this.isLoading=false
             this.key+=1
          });
      }, 
    }
  };
</script>
